import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux'
import { Encabezado } from '../../Components/Encabezado/Encabezado'

import { 
    Paper, 
    Box,
    TableContainer,
    Table, 
    TableBody, 
    TableCell, 
    TableHead, 
    TableRow,
    TablePagination,
    Typography
} from '@mui/material'

import {
  Search,
} from "@mui/icons-material";

import { CgLockUnlock } from "react-icons/cg";

import Loading from "../../Components/Modals/Loading/Loader";

import { 
    fetchGetCafeteriaRestriccionList,
    fetchGetCafeteriaRestriccionListCount,
    fetchUnlockEmpleadoRestriccionComida,
    fetchCambiarSuccess,
    selectRestriccionUsuariosList,
    selectRestriccionUsuariosListCount,
    selectIsLoading,
    selectIsSuccess,
    selectMessage
} from '../../redux/Cafeteria/CafeteriaSlice';

import { selectUserData } from '../../redux/Login/LoginSlice';

import moment from 'moment';
import swal from 'sweetalert';
import { IoAddCircle } from 'react-icons/io5';

export const UsuariosBloqueadosCafeteria = () => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-NAVEGACION
    const navigate = useNavigate();

    // ? HOOK-SELECTOR
    const restriccionUsuariosList = useSelector(selectRestriccionUsuariosList);
    const restriccionUsuariosListCount = useSelector(selectRestriccionUsuariosListCount);
    const isLoading = useSelector(selectIsLoading);
    const success = useSelector(selectIsSuccess);
    const message = useSelector(selectMessage);

    // ? HOOK-SELECTOR DE USUARIO ACTUALMENTE LOGUEADO.
    const { Id: usuarioId } = useSelector(selectUserData);

    // ? USE-STATE PARA LA PAGINACION
    const [ page, setPage ] = useState(0);
    const [ rowsPerPage, setRowsPerPage ] = useState(25);
    const [ skipRow, setSkipRow ] = useState(0);
    const [ empleado, setEmpleado ] = useState('');
    
    // ? HOOK-EFFECT
    useEffect(() => {
        refreshList();
    }, [])
   
    useEffect(() => {
        refreshList();
    }, [page, rowsPerPage, skipRow])
    
    
    // ? HOOK-EFFECT PARA SWEET-ALERT
    useEffect(() => {

        if (success === "success" && message.length > 0) {
            swal("Exitoso!", message, "success", {
                timer: 2000,
            });

            dispatch(fetchCambiarSuccess());
            
            // * REFRESCAR TODAS LAS LISTAS NUEVAMENTE.
            refreshList();
        } 
        else if (success === "error") {
            swal("Error", message, "error", {
                timer: 4000
            });

            dispatch(fetchCambiarSuccess());
        }
    }, [success]);

    // * FUNCIONES PARA PAGINACION.
    const handleChangePage = (event, newPage) => {
        setSkipRow(newPage * rowsPerPage);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setSkipRow(0);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          refreshList();
        }
      };

    // * FUNCION PARA REFRESCAR LISTA
    const refreshList = () => {
        dispatch(fetchGetCafeteriaRestriccionList({index: page, itemsPerPage: rowsPerPage, nombreEmpleadoFilter: empleado}))
        dispatch(fetchGetCafeteriaRestriccionListCount(empleado));
    }
    
    // * FUNCION PARA DESBLOQUEAR UN USUARIO
    const unlockUser = (item) => {
        // * MENSAJE DE CONFIRMACION
        swal({
            title: 'Advertencia',
            text: `Estás seguro/a que desea desbloquear a ${item.empleado}?`,
            icon: 'warning',
            buttons: ['No', 'Si']
        }).then(respuesta => {
            if(respuesta){
                dispatch(fetchUnlockEmpleadoRestriccionComida({ RestriccionId: item.id, usuarioModificado:  usuarioId}));
            }
        })
    }

    return (
    <Encabezado title={'Bloqueo de selección de almuerzo'}>
        
        <div className="row border m-1 p-2 d-flex justify-content-between">
            <div className="col-8">
                <div className="input-group mt-2">
                    <label className="me-2 align-self-center">Empleado</label>
                    <input
                    className="form-control"
                    value={empleado}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => {
                        e.preventDefault();
                        setEmpleado(e.target.value);
                    }}
                    type="text"
                    />
                    <button
                    id="btn-search-empleado"
                    className="btn btn-primary-mem"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Buscar Empleado"
                    type="button"
                    onClick={() => refreshList()}
                    >
                    <Search />
                    </button>
                </div>
            </div>
            <div className='col-4'>
               <div className='d-flex justify-content-end mt-2'>
                    <button className='btn btn-primary-mem' onClick={() => navigate('/cafeteria/restriccion/agregar')}>Agregar Usuarios <IoAddCircle style={{marginBottom: 3}} fontSize='22' /></button>
               </div>
            </div>
        </div>

        <Box sx={{ mt: 3 }} maxWidth={'100%'}>
            <Paper sx={{ mb: 2 }} elevation={3}>
                <TableContainer>
                    <Table component={Paper}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{fontWeight: 'bold'}}>
                                    Empleado
                                </TableCell>
                                <TableCell align='center' sx={{fontWeight: 'bold'}}>
                                    Fecha de Creación
                                </TableCell>
                                <TableCell>
                                    
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                        {
                            restriccionUsuariosList?.length > 0 ?
                                restriccionUsuariosList.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {item.empleado}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {moment(item.fechaCreacion).format("DD/MM/YYYY")}
                                        </TableCell>
                                        <TableCell align='right'>
                                            <button onClick={() => unlockUser(item)} className='btn btn-primary-mem'>Desbloquear <CgLockUnlock fontSize={22} style={{marginTop: -2}} /></button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            :
                            <TableCell colSpan={6} align='center'>
                                <Typography>No hay registros</Typography>
                            </TableCell>
                        }
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                rowsPerPageOptions={[25, 50, 100]}
                component="div"
                count={restriccionUsuariosListCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>

        <Loading open={isLoading} />
    </Encabezado>
  )
}
